import { render, staticRenderFns } from "./RecentActivityTableDescriptionInvoiceMarkedOverdue.vue?vue&type=template&id=32a3ee90&"
import script from "./RecentActivityTableDescriptionInvoiceMarkedOverdue.vue?vue&type=script&lang=js&"
export * from "./RecentActivityTableDescriptionInvoiceMarkedOverdue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports